/**
 * Fechas de listado/detalle OV: `YYYY-MM-DD` del API como día calendario local (sin desfase UTC).
 */

/**
 * @param {unknown} value
 * @returns {Date|null}
 */
export function parseSalesOrderDisplayDate(value) {
  if (value == null || value === '') return null;
  if (typeof value === 'number' && Number.isFinite(value)) {
    const ms = value > 0 && value < 1e12 ? value * 1000 : value;
    const d = new Date(ms);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const s = String(value).trim();
  if (!s) return null;

  const ymdOnly = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (ymdOnly) {
    const d = new Date(Number(ymdOnly[1]), Number(ymdOnly[2]) - 1, Number(ymdOnly[3]));
    return Number.isNaN(d.getTime()) ? null : d;
  }

  let d = new Date(s);
  if (!Number.isNaN(d.getTime())) return d;

  const m = s.match(/^(\d{1,2})[/.-](\d{1,2})[/.-](\d{2,4})$/);
  if (m) {
    const day = parseInt(m[1], 10);
    const month = parseInt(m[2], 10) - 1;
    let year = parseInt(m[3], 10);
    if (year < 100) year += 2000;
    d = new Date(year, month, day);
    if (!Number.isNaN(d.getTime())) return d;
  }
  return null;
}

/**
 * @param {unknown} value
 * @param {string} [emptyLabel]
 * @returns {string}
 */
export function formatSalesOrderDisplayDateEsCl(value, emptyLabel = '—') {
  if (value == null || value === '') return emptyLabel;
  const d = parseSalesOrderDisplayDate(value);
  if (!d) {
    if (typeof value === 'string' && value.trim()) return value.trim();
    return emptyLabel;
  }
  return d.toLocaleDateString('es-CL', { day: '2-digit', month: '2-digit', year: 'numeric' });
}
